import React from 'react';
import {findDOMNode} from "react-dom"
import CustomView from "../../../../core/model2/custom-view/custom-view";
import NavigationMenuItem from "../menu-item";
import {NavigationSectionType} from "../../../../core/model2/navigation/@const";
import {PopoverMenuItemType} from "../../../../core/gd-components/popover-menu/popover-menu/const";
import NavigationSection from "../../../../core/model2/navigation/navigation-section";
import navigation_pin from "../../../navigation/actions/pin";
import navigation_unpin from "../../../navigation/actions/unpin";
import {ViewTypeConfigs} from "../../../../core/gd/const/views/view-type-config";
import {ViewType} from "../../../../core/gd/const/views/view-type";
import {BUS_APP_LAUNCH} from "../../../../core/gd/app-manager/@event"

type State = {
    selected        : boolean,
    useHint         : boolean
}

type Props = {
    navigationSection   : NavigationSection
    viewId              : ID | ViewType,
    style?              : style
    dndPreview?         : any
    dndIsDragged?       : boolean
}

export default class NavigationMenuItemCustomView extends React.Component<Props,State> {

    public view                     : CustomView
    public debouncedCheckHint       : any

    constructor(props:Props) {
        super(props)

        // @ts-ignore
        this.view = gd.session.customViews.get(this.props.viewId)

        this.state = {
            selected    : this.view.isOpen(),
            useHint     : false
        }

        this.debouncedCheckHint = _.debounce(this._checkHintUsage, 300)
    }

    componentDidMount() {
        gd.bus.subscribe(BUS_APP_LAUNCH, this, this.onLaunchApp)

        this.debouncedCheckHint()
    }

    componentDidUpdate() {
        this.debouncedCheckHint()
    }

    componentWillUnmount = () => {
        this.debouncedCheckHint.cancel()

        gd.bus.unsubscribe(this)
    };

    _checkHintUsage = () => {
        const useHint = gd.utils.getTextExceedsNodeWidth(this.view.name, findDOMNode(this), 56, 14)

        if (this.state.useHint !== useHint) {
            this.setState({
                useHint: useHint
            })
        }
    }

    onLaunchApp = (params:any) => {
        // just in case
        if (!this.view) return

        if (this.state.selected)    !this.view.isOpen() && this.setState({selected: false})
        else                        this.view.isOpen() && this.setState({selected: true})
    }

    onEdit = () => {
        gd.modal.isOpen && gd.modal.hide(); //if delete or settings modal already visible
        // this.hidePopover();

        gd.goTo('v/{0}/{1}/info'.f(ViewTypeConfigs[this.view.type as ViewType]!.url, this.view.id))
    };

    onDelete = () => {
        // gd.modal.isOpen && gd.modal.hide(); //if delete or settings modal already visible
        // this.hidePopover()

        this.view.actions.delete()
    };

    // onClick = () => {
    //     this.view.open()
    // }

    setDisplayIn = async (displayIn: NavigationSectionType) => {

        this.view.location = displayIn
        // this.view.saveParams()

        switch (displayIn) {
            case NavigationSectionType.NAVIGATION_PANEL:
                await navigation_pin('view-'+this.view.id)
                // await navigation_pinAndGoTo('view-'+this.view.id,this.view.url)
                break
            case NavigationSectionType.HOME:
                await navigation_unpin('home')
                // await navigation_unpinAndGoTo('home',this.view.url)
                break
        }

    }

    render () {
        // patch to prevent errors
        if (!this.view) return false

        const canDelete = !this.view.isSharedWithMe || this.view.isSingleton || this.view.canEdit

        const moreOptions : Option[] = [
            {
                label       : "Info",
                icon        : "ii5-information",
                disabled    : !this.view.canEdit,
                onClick     : this.onEdit
            },
            {
                label       : "Delete",
                icon        : "i5-trash-alt",
                onClick     : this.onDelete,
                disabled    : !canDelete
            },
            {
                type    : PopoverMenuItemType.SEPARATOR
            },
            {
                type    : PopoverMenuItemType.HEADER,
                label   : 'Display In:'
            },
        ]

        // add display options
        _.map(this.view.locationOptions, (option:Option) => {
            option              = _.clone(option)    // because we modify it below
            option.isSelected   = option.value === this.view.location
            option.onClick      = () => { this.view.location = option.value as NavigationSectionType }
            moreOptions.push(option)
        })

        const classes = Classes('viewId-'+this.view.id /*required for scroll to node*/)

        return (
            <NavigationMenuItem className       = {classes}
                                name            = {this.view.name}
                                selected        = {this.state.selected}
                                icon            = {Classes('icon', this.view.icon)}
                                style           = {this.props.style}
                                dndPreview      = {this.props.dndPreview}
                                dndIsDragged    = {this.props.dndIsDragged}
                                url             = {this.view.url}
                                moreMenuOptions = {moreOptions}
                                isShared        = {this.view.isSharedWithMe}
                                {...this.props}/>
        )

    }
}
